import Api from './Api';

const END_POINT = "doctors";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    // console.log(request);
    return await Api.get(`${END_POINT}`, request);
  },
  async get_allPaginated(filters = null) {
    let request = {
        params: filters
    }
    return await Api.get(`${END_POINT}-list-paginated`, request);
},
  async store(doctor) {
    return await Api.post(`${END_POINT}`, doctor);
  },
  async update(doctor) {
    return await Api.patch(`${END_POINT}/${doctor.id}`, doctor);
  },
  async change_status(doctor) {
    return await Api.patch(`${END_POINT}/${doctor.id}/change-status`, doctor);
  },
  async delete(doctor) {
    return await Api.delete(`${END_POINT}/${doctor.id}`, doctor);
  },
  async search_document(document) {
    return await Api.get(`https://apispa.wost.pe/api/customers/${document}/search-document`)
    // return await Api.get(`${END_POINT}/${document}/search-document`);

  },
  download(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/download-doctors`, request);
  },
  async upload(doctor) {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return Api.post(`${END_POINT}/upload`, doctor, config);
}
};
